import api from './client';

export const subscribeNewsletter = (data) => api.post('/newsletter/subscribe', data).then((r) => r.data);
